

























































import { Customer } from '@/models/customer';
import { ErrorManager } from '@/models/error';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ErrorAlert from '../common/ErrorAlert.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';
import { AxiosError } from 'axios';
export default Vue.extend({
  components: { ErrorAlert, ALDialog },
  name: 'CustomerActivitiesHistoryLogDialog',

  data: () => ({
    loading: true,
    dialog: false,
    errorMessage: '',
    detailErrorMessage: ''
  }),

  computed: {
    ...mapGetters({
      getCustomerPricingActivities: 'customer/getCustomerPricingActivities'
    }),

    noCustomersPricingActivities(): boolean {
      return this.getCustomerPricingActivities.length == 0;
    }
  },

  methods: {
    ...mapActions({
      fetchCustomerPricingHistory: 'customer/fetchCustomerPricingHistory'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(customer: Customer) {
      this.dialog = true;
      this.initalize(customer.id!);
    },

    async initalize(customerId: string) {
      this.loading = true;

      try {
        await this.fetchCustomerPricingHistory(customerId);
      } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.dialog = false;
    }
  }
});
